import {
  ApiOutlined,
  PlusOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { useEffect, useMemo, useRef, useState, useCallback } from "react";
import DataTable from "../../../../Components/DataTable/DataTable";
import styles from "./QuestionsToFlags.module.css";
import {
  Button,
  Divider,
  Input,
  Modal,
  Select,
  Skeleton,
  Space,
  Tag,
  message,
  Table,
  Popconfirm,
} from "antd";
import { connect } from "react-redux";
import * as actions from "../../../../store/actions/action";
import { editError } from "../../../../Util/Messages";
import api from "../../../../api/api";
import Flags from "../../Flags/Flags";
import ExportExcel from "../../../../Util/ExportExcel";
import CheckPermission from "../../../../Util/CheckPermission";
import { useParams } from "react-router-dom";
import { findFlagRef } from "../../UserRoadmap/UserRoadmap";

const QuestionsToFlags = ({
  LoadingSetter,
  ClearLoading,
  loading,
  questions,
  questionTypesData,
  loadData,
  permissions,
}) => {
  const params = useParams();

  const [flagsStat, setFlagStat] = useState([]);
  const [flagsTag, setFlagsTag] = useState([]);
  const [ignoreTag, setIgnoreTags] = useState([]);
  const [ignoreFlags, setIgnoreFlags] = useState([]);
  const [tempFlagsIndex, setTempFlagsIndex] = useState([]);
  const [data, setData] = useState([]);
  const dataRef = useRef(null);
  const [openModal, setOpenModal] = useState(false);
  const [openIgnoreFlagModal, setOpenIgnoreFlagModal] = useState(false);
  const [editingRecord, setEditingRecord] = useState();
  const [flags, setFlags] = useState([]);
  const [formAdjectives, setFormAdjectives] = useState([]);
  const [importantQuestions, setImportantQuestions] = useState([]);
  const [openImportantQuestionsModal, setOpenImportantQuestionsModal] =
    useState(false);
  const [newQuestionNumber, setNewQuestionNumber] = useState("");
  const [newAnswerId, setNewAnswerId] = useState("");

  const adjectiveList = useMemo(
    () => Array.from(new Set(formAdjectives.map((e) => e.adjective))),
    [formAdjectives]
  );

  const getFlagImportance = (row, flagId) => {
    if (row.isOption) {
      const exists = tempFlagsIndex.find(
        (i) =>
          i.id === row.id &&
          i.answer_id === row.anwser_id &&
          i.flagId === flagId
      );

      return exists?.importance ?? 0;
    } else {
      let exists = tempFlagsIndex.find(
        // (i) => i.answer_id === row.id && i.flagId === flagId && !i.id
        (i) => i.id === row.id && i.flagId === flagId && !i.answer_id
      );
      if (!exists) {
        exists = tempFlagsIndex.find(
          (i) => i.answer_id === row.id && i.flagId === flagId && !i.id
        );
      }

      return exists?.importance ?? 0;
    }
  };

  const getFlagTermIndexVal = (row, flagId) => {
    if (row.isOption) {
      const exists = tempFlagsIndex.find(
        (i) =>
          i.id === row.id &&
          i.answer_id === row.anwser_id &&
          i.flagId === flagId
      );

      return exists?.value ?? 0;
    } else {
      let exists = tempFlagsIndex.find(
        // (i) => i.answer_id === row.id && i.flagId === flagId && !i.id
        (i) => i.id === row.id && i.flagId === flagId && !i.answer_id
      );
      if (!exists) {
        exists = tempFlagsIndex.find(
          (i) => i.answer_id === row.id && i.flagId === flagId && !i.id
        );
      }

      return exists?.value ?? 0;
    }
  };

  const getFlags = () => {
    api
      .get("/flags", { params: { page: 1, pageSize: 3000, all: true } })
      .then((res) => {
        setFlags(res.data.data);
      })

      .catch(() => message.error("خطا در دریافت کارت ها"));
  };

  const saveIgnoreTags = (questionId, answerId, tags) => {
    api
      .post("/question-ignore-tag", {
        questionId,
        answerId,
        tags,
        formId: params.epollformid,
      })
      .then(() => {})
      .catch(() => message.error("خطا در ثبت تگ ها"))
      .finally(() => getFlagIgnoreTags());
  };

  const saveIgnoreFlags = (questionId, answerId, flagsId) => {
    api
      .post("/question-ignore-flag", {
        questionId,
        answerId,
        flagsId,
        formId: params.epollformid,
      })
      .then(() => {})
      .catch(() => message.error("خطا در ثبت کارت های حذفی"))
      .finally(() => getIgnoreFlagsList());
  };

  const changeFlagIndex = (value, row, flagId) => {
    const importance = getFlagImportance(row, flagId);

    setTempFlagsIndex((prev) => {
      if (row.isOption) {
        const newArr = prev.filter(
          (i) =>
            !(
              i.answer_id === row.anwser_id &&
              i.id === row.id &&
              flagId === i.flagId
            )
        );

        return [
          ...newArr,
          {
            answer_id: row.anwser_id,
            id: row.id,
            flagId,
            value,
            importance,
          },
        ];
      } else {
        const newArr = prev.filter(
          (i) =>
            !(i.id === row.id && flagId === i.flagId && i.answer_id === null)
        );

        return [
          ...newArr,
          {
            id: row.id,
            flagId,
            value,
            importance,
          },
        ];
      }
    });
  };

  const changeFlagImportance = (importance, row, flagId) => {
    const termIndex = getFlagTermIndexVal(row, flagId);

    setTempFlagsIndex((prev) => {
      if (row.isOption) {
        const newArr = prev.filter(
          (i) =>
            !(
              i.answer_id === row.anwser_id &&
              i.id === row.id &&
              flagId === i.flagId
            )
        );

        return [
          ...newArr,
          {
            answer_id: row.anwser_id,
            id: row.id,
            flagId,
            value: termIndex,
            importance,
          },
        ];
      } else {
        const newArr = prev.filter(
          (i) =>
            !(i.id === row.id && flagId === i.flagId && i.answer_id === null)
        );

        return [
          ...newArr,
          {
            id: row.id,
            flagId,
            value: termIndex,
            importance,
          },
        ];
      }
    });
  };

  const getFlagsTag = () => {
    api
      .get("/flags/tags")
      .then((res) => setFlagsTag(res.data))
      .catch(() => message.error("خطا در دریافت تگ ها"));
  };

  const getIgnoreFlagsOfQuestion = (questionId, answerId) => {
    const res = ignoreFlags?.filter((ignoreFlag) =>
      answerId
        ? `${ignoreFlag.question_id}` === `${questionId}` &&
          `${ignoreFlag.answer_id}` === `${answerId}`
        : `${ignoreFlag.question_id}` === `${questionId}` &&
          ignoreFlag.answer_id === null
    );

    return res ?? [];
  };

  const getIgnoreFlagsList = () => {
    api
      .get(`/question-ignore-flag/${params.epollformid}`)
      .then(({ data }) => setIgnoreFlags(data))
      .catch(() => message.error("خطا در دریافت کارت های حذفی"));
  };

  const loadImportantQuestions = useCallback(() => {
    api
      .get("/important-questions", {
        params: { formId: params.epollformid },
      })
      .then(({ data }) => {
        setImportantQuestions(data.data || []);
      })
      .catch(() => message.error("خطا در دریافت سوالات مهم"));
  }, [params.epollformid]);

  const addImportantQuestion = (questionId, optionId = null) => {
    const payload = {
      formId: params.epollformid,
      questionId,
      optionId,
    };

    api
      .post("/important-questions", payload)
      .then(() => {
        message.success("سوال مهم با موفقیت اضافه شد");
        loadImportantQuestions();
      })
      .catch(() => message.error("خطا در افزودن سوال مهم"));
  };

  const deleteImportantQuestion = (id) => {
    api
      .delete(`/important-questions/${id}`)
      .then(() => {
        message.success("سوال مهم با موفقیت حذف شد");
        loadImportantQuestions();
      })
      .catch(() => message.error("خطا در حذف سوال مهم"));
  };

  const isMainQuestionImportant = (questionId) => {
    if (!Array.isArray(importantQuestions) || importantQuestions.length === 0) {
      return false;
    }

    return importantQuestions.find(
      (iq) => iq.questionId == questionId && iq.optionId == null
    );
  };

  const isRecordImportant = (record) => {
    if (!Array.isArray(importantQuestions) || importantQuestions.length === 0) {
      return false;
    }

    const questionId = record.isOption ? record.anwser_id : record.id;
    const optionId = record.isOption ? record.id : null;

    // Check if this specific record is marked as important
    const isDirectlyImportant = importantQuestions.find(
      (iq) => iq.questionId == questionId && iq.optionId == optionId
    );

    // For options, also check if parent question is important
    if (record.isOption && !isDirectlyImportant) {
      return isMainQuestionImportant(questionId);
    }

    return isDirectlyImportant;
  };

  const toggleImportantQuestion = (record) => {
    // Prevent toggling options to not-important if parent question is important
    if (record.isOption) {
      const parentQuestionId = record.anwser_id;
      const isParentImportant = isMainQuestionImportant(parentQuestionId);
      const isCurrentlyImportant = isRecordImportant(record);

      // If trying to remove importance from option but parent is important, prevent it
      if (isCurrentlyImportant && isParentImportant) {
        message.warning(
          "نمی‌توان اهمیت گزینه را حذف کرد در حالی که سوال اصلی مهم است"
        );
        return;
      }
    }

    const questionId = record.isOption ? record.anwser_id : record.id;
    const optionId = record.isOption ? record.id : null;

    const existingImportant = importantQuestions.find(
      (iq) => iq.questionId == questionId && iq.optionId == optionId
    );

    if (existingImportant) {
      deleteImportantQuestion(existingImportant.id);
    } else {
      addImportantQuestion(questionId, optionId);
    }
  };

  useEffect(() => {
    api.get("/flags/report").then(({ data }) => {
      setFlagStat(data.data);
    });

    getFlagsTag();
    getFlagIgnoreTags();
    getIgnoreFlagsList();
    getFlags();
    getRelation();
    loadImportantQuestions();
  }, []);

  const findFlag = (flagId) => flags.find((fl) => fl.id === flagId);

  const getRelation = () => {
    // get flags
    api.get("/flags-relation/" + params.epollformid).then(({ data }) => {
      setTempFlagsIndex(
        data.map((i) => ({
          value: i.termIndex,
          flagId: i.flag,
          id: i.answer_id,
          answer_id: i.question_id,
          importance: i?.importance ?? 0,
        }))
      );
    });
  };

  const getFlagIgnoreTags = () => {
    api
      .get(`/question-ignore-tag/${params.epollformid}`)
      .then(({ data }) => setIgnoreTags(data))
      .catch(() => message.error("خطا در دریافت تگ های متصل"));
  };

  const getFlagSta = (flagId) => {
    const flag = flagsStat?.find((flag) => flag.id === flagId);

    return {
      total: flag?.totalCount ?? -1,
      term1: flag?.term1 ?? -1,
      term2: flag?.term2 ?? -1,
      term3: flag?.term3 ?? -1,
      term4: flag?.term4 ?? -1,
    };
  };

  const loadFormAdjectives = () => {
    api
      .get(`/question-adjective/${params.epollformid}`)
      .then((res) => {
        setFormAdjectives(res.data);
      })
      .catch(() => message.error("خطا در دریافت صفت ها"));
  };

  const saveQAAdjectives = (questionId, answerId, adjectives) => {
    api
      .post(`/question-adjective`, {
        formId: params.epollformid,
        answerId,
        questionId,
        adjectives: Array.from(
          new Set((adjectives ?? []).filter((e) => e).map((e) => e.trim()))
        ),
      })
      .then((res) => {})
      .catch(() => message.error("خطا در ثبت صفت ها"))
      .finally(() => {
        loadFormAdjectives();
      });
  };

  const getQAAdjectives = (questionId, answerId) => {
    return formAdjectives
      .filter((e) => e.questionId == questionId && e.answerId == answerId)
      .map((e) => e.adjective);
  };

  const getQAAndOptionsAdjectives = (questionId) => {
    return formAdjectives
      .filter((e) => e.questionId === questionId || e.answerId === questionId)
      .map((e) => e.adjective);
  };

  const [editableKeys, setEditableRowKeys] = useState();
  const [questionTypes, setQuestionTypes] = useState([]);
  const [newQuestionType, setNewQuestionType] = useState("");
  const newQuestionTypeInputRef = useRef(null);

  const flagsMapper = (ids, row, editing = false) => {
    if (Array.isArray(flags) && flags.length > 0) {
      if (Array.isArray(ids)) {
        return ids.map((id) => {
          let element = null;

          flags.forEach((flag) => {
            if (id === flag.id) {
              const stat = getFlagSta(flag.id);
              element = (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "rgba(0,0,0,0.05)",
                    height: "3rem",
                    paddingLeft: "0.5rem",
                    paddingRight: "0.5rem",
                  }}
                >
                  {/* flag title */}
                  <div style={{ width: "42%" }}>{flag.title}</div>
                  {/* term placement */}
                  <div style={{ width: "12.5%" }}>
                    <Select
                      disabled={!editing}
                      size="small"
                      value={getFlagTermIndexVal(row, flag.id)}
                      style={{ width: "100%" }}
                      onChange={(value) => {
                        changeFlagIndex(parseInt(value), row, flag.id);
                      }}
                      options={[
                        { value: 0, label: "صفر" },
                        { value: 1, label: "یک" },
                        { value: 2, label: "دو" },
                        { value: 3, label: "سه" },
                        { value: 4, label: "چهار" },
                      ]}
                    />
                  </div>
                  {/* flag importance */}
                  <div style={{ width: "12.5%" }}>
                    <Select
                      disabled={!editing}
                      size="small"
                      value={getFlagImportance(row, flag.id)}
                      style={{ width: "100%" }}
                      onChange={(value) => {
                        changeFlagImportance(parseInt(value), row, flag.id);
                      }}
                      options={[
                        { value: 0, label: "صفر" },
                        { value: 1, label: "اول" },
                        { value: 2, label: "دوم" },
                        { value: 3, label: "سوم" },
                      ]}
                    />
                  </div>
                  {/* stat */}
                  <div
                    style={{
                      width: "33%",
                      textAlign: "end",
                      height: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        height: "100%",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          width: "20%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          height: "100%",
                        }}
                      >
                        {stat.term1}
                      </div>

                      <div
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          width: "20%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          height: "100%",
                        }}
                      >
                        {stat.term2}
                      </div>

                      <div
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          width: "20%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          height: "100%",
                        }}
                      >
                        {stat.term3}
                      </div>

                      <div
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          width: "20%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          height: "100%",
                        }}
                      >
                        {stat.term4}
                      </div>

                      <div
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          width: "20%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          height: "100%",
                        }}
                      >
                        {stat.total}
                      </div>
                    </div>
                  </div>
                </div>
              );
            }
          });

          return element;
        });
      }
    } else {
      return (
        <Space>
          <Skeleton.Input active />
          <Skeleton.Input active />
          <Skeleton.Input active />
        </Space>
      );
    }
  };

  const getIgnoreTag = (questionId, answerId) => {
    return ignoreTag
      .filter((tData) =>
        answerId
          ? `${tData.answer_id}` === `${answerId}` &&
            `${tData.question_id}` === `${questionId}` &&
            `${tData.form_id}` === `${params.epollformid}`
          : `${tData.question_id}` === `${questionId}` &&
            `${tData.form_id}` === `${params.epollformid}`
      )
      .map(({ tag }) => tag);
  };

  const onNameChange = (event) => {
    setNewQuestionType(event.target.value);
  };

  const addItem = (e) => {
    e.preventDefault();
    api.post("/question-types", { title: newQuestionType }).then((res) => {
      setQuestionTypes([...questionTypes, res.data]);
      setNewQuestionType("");
      setTimeout(() => {
        newQuestionTypeInputRef.current?.focus();
      }, 0);
    });
  };
  const columns = [
    {
      title: "سوال",
      dataIndex: "title",
      width: "18%",
      // filters: [{ value: 'hasOption' , text: 'گزینه‌دار' } , { value: 'noOption' , text: 'بدون گزینه'}],
      // onFilter: (value, record) => {
      //     if (value==='hasOption') {
      //       return Array.isArray(record.children)
      //     }
      //     if (value==='noOption') {
      //       return !Array.isArray(record.children)
      //     }
      // },
      searchable: true,
      editable: false,
    },
    {
      title: "مهم",
      dataIndex: "important",
      width: "3%",
      filters: [
        { value: true, text: "مهم" },
        { value: false, text: "غیر مهم" },
      ],
      onFilter: (value, record) => {
        return !!isRecordImportant(record) === value;
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          const isImportant = isRecordImportant(record);
          const isParentImportant = record.isOption
            ? isMainQuestionImportant(record.anwser_id)
            : false;
          const isDisabled =
            record.isOption && isParentImportant && isImportant;

          return (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <ExclamationCircleOutlined
                style={{
                  color: isImportant ? "red" : "gray",
                  fontSize: "16px",
                  cursor: isDisabled ? "not-allowed" : "pointer",
                  opacity: isDisabled ? 0.6 : 1,
                }}
                onClick={() => {
                  if (!isDisabled) {
                    toggleImportantQuestion(record);
                  }
                }}
              />
            </div>
          );
        }
      },
      render: (value, record) => {
        const isImportant = isRecordImportant(record);
        const isParentImportant = record.isOption
          ? isMainQuestionImportant(record.anwser_id)
          : false;
        const isDisabled = record.isOption && isParentImportant && isImportant;

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <ExclamationCircleOutlined
              style={{
                color: isImportant ? "red" : "gray",
                fontSize: "16px",
                cursor: isDisabled ? "not-allowed" : "pointer",
                opacity: isDisabled ? 0.6 : 1,
              }}
              onClick={() => {
                if (!isDisabled) {
                  toggleImportantQuestion(record);
                }
              }}
            />
          </div>
        );
      },
    },
    {
      title: "نوع",
      dataIndex: "types",
      filters: questionTypes.map((q) => {
        return { value: q.id, text: q.title };
      }),
      onFilter: (value, record) => {
        if (record.types) {
          return record.types.includes(value);
        } else {
          return true;
        }
      },
      width: "7%",
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <Select
              showSearch={false}
              showArrow
              placeholder="انتخاب کنید"
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <Divider
                    style={{
                      margin: "8px 0",
                    }}
                  />
                  <Space
                    style={{
                      padding: "0 8px 4px",
                    }}
                  >
                    <Input
                      placeholder="نام نوع جدید"
                      ref={newQuestionTypeInputRef}
                      value={newQuestionType}
                      onChange={onNameChange}
                    />
                    <Button
                      type="dashed"
                      icon={<PlusOutlined />}
                      onClick={addItem}
                    />
                  </Space>
                </>
              )}
              mode="multiple"
            >
              {questionTypes.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.title}
                  </Select.Option>
                );
              })}
            </Select>
          );
        }
      },
      render: (ids, row) => {
        return questionTypes.map((type) => {
          let element = null;
          if (Array.isArray(ids)) {
            ids.forEach((id) => {
              if (id === type.id) {
                element = <Tag>{type.title}</Tag>;
              }
            });
          }
          return element;
        });
      },
    },
    // ignore tags
    {
      title: <span style={{ whiteSpace: "nowrap" }}>حذف بر پایه تگ</span>,
      dataIndex: "flagTag",
      width: 130,
      filterSearch: true,
      filters: flagsTag.map((q) => {
        return { value: q, text: q };
      }),
      onFilter: (value, record) => {
        const tags = getIgnoreTag(record.id, record.anwser_id);

        record?.children?.forEach((child) => {
          const childTags = getIgnoreTag(child.id, record.id);
          tags.push(...childTags);
        });

        return tags?.indexOf(value) !== -1;
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (record.children) return;
        if (isEditable && record.isOption) {
          // const tags = getIgnoreTag(record.id, record.anwser_id);
          // const tags = record?.flagTag ?? [];
          const tags = Array.from(
            new Set([
              ...getIgnoreTag(record.id, record.anwser_id),
              ...(record?.flagTag ?? []),
            ])
          );

          return (
            <Select
              defaultValue={tags}
              showSearch={true}
              showArrow
              placeholder="انتخاب کنید"
              mode="multiple"
            >
              {flagsTag.map((tag) => {
                return (
                  <Select.Option key={tag} value={tag}>
                    {tag}
                  </Select.Option>
                );
              })}
            </Select>
          );
        }
      },
      render: (ids, row) => {
        if (row.children) {
          for (const child of row.children) {
            const childTags = Array.from(
              new Set([
                ...getIgnoreTag(child.id, child.anwser_id),
                ...(child?.flagTag ?? []),
              ])
            );
            if (childTags.length > 0) {
              return <Tag color="blue">دارد</Tag>;
            }
          }
          return <Tag color="red">ندارد</Tag>;
        }

        const tags = Array.from(
          new Set([
            ...getIgnoreTag(row.id, row.anwser_id),
            ...(row?.flagTag ?? []),
          ])
        );

        if (tags.length === 0) return <Tag color="red">ندارد</Tag>;

        return tags.map((a) => <Tag>{a}</Tag>);
      },
    },

    // ignore flags
    {
      title: <span style={{ whiteSpace: "nowrap" }}>کارت های حذفی</span>,
      width: 120,
      filterSearch: true,
      filters: (flags ?? [])?.map((fl) => ({
        value: fl.id,
        text: fl.title,
      })),
      onFilter: (value, record) => {
        const ignoreFlagList = getIgnoreFlagsOfQuestion(record?.id, null);

        record?.children?.forEach((child) => {
          const childTags = getIgnoreFlagsOfQuestion(record?.id, child.id);
          ignoreFlagList.push(...childTags);
        });

        return ignoreFlagList.find((el) => el?.bom_item?.id === +value);
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable && record.isOption) {
          const ignoreFlagList = getIgnoreFlagsOfQuestion(
            record?.isOption ? record?.anwser_id : record?.id,
            record?.isOption ? record?.id : null
          );

          return (
            <>
              <Button
                onClick={() => {
                  setOpenIgnoreFlagModal(true);
                  setEditingRecord({
                    ...record,
                    ignoreFlags: [...(record?.ignoreFlags ?? [])],
                  });
                }}
              >
                انتخاب
              </Button>

              {ignoreFlagList?.map((a) => (
                <Tag>{a?.bom_item?.title}</Tag>
              ))}
            </>
          );
        }
      },
      render: (ids, row) => {
        const ignoreFlagList = getIgnoreFlagsOfQuestion(
          row?.isOption ? row?.anwser_id : row?.id,
          row?.isOption ? row?.id : null
        );

        const childFlagList = [];
        if (ignoreFlagList?.length === 0) {
          row?.children?.forEach((child) => {
            const childTags = getIgnoreFlagsOfQuestion(row?.id, child.id);
            childFlagList.push(...childTags);
          });

          if (childFlagList.length === 0) {
            return <Tag color="red">ندارد</Tag>;
          }
          return <Tag color="blue">دارد</Tag>;
        }

        return ignoreFlagList?.map((a) => <Tag>{a?.bom_item?.title}</Tag>);
      },
    },
    {
      title: "صفات",
      dataIndex: "qaAdjective",
      width: "10%",
      filterMultiple: false,
      filterSearch: true,
      filters: adjectiveList.map((q) => {
        return { value: q, text: q };
      }),
      onFilter: (value, record) => {
        return getQAAndOptionsAdjectives(record.id).includes(value);
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          const adjectives = getQAAdjectives(record.anwser_id, record.id);
          return (
            <Select
              defaultValue={adjectives}
              showSearch={true}
              showArrow
              placeholder="انتخاب کنید"
              mode="tags"
            >
              {adjectiveList.map((adj) => {
                return (
                  <Select.Option key={adj} value={adj}>
                    {adj}
                  </Select.Option>
                );
              })}
            </Select>
          );
        }
      },
      render: (_, row) => {
        const adjectives = getQAAdjectives(row.anwser_id, row.id);
        if (adjectives.length === 0) return <Tag color="red">ندارد</Tag>;
        return adjectives.map((a) => <Tag>{a}</Tag>);
      },
    },
    // flags
    {
      title: "کارت‌ها",
      dataIndex: "flags",
      filters:
        Array.isArray(flags) &&
        flags.map((flag) => {
          return {
            value: flag.id,
            text: flag.title,
            ...flag,
          };
        }),
      filterSearch: true,
      onFilter: (value, record) => {
        if (Array.isArray(record.allFlags)) {
          let has = false;
          record.allFlags.forEach((el) => {
            if (el === value) {
              has = true;
            }
          });
          return has;
        }
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <div>
              <Button
                onClick={() => {
                  setOpenModal(true);
                  setEditingRecord(record);
                }}
              >
                انتخاب
              </Button>

              <div>
                {/* header */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "rgba(0,0,0,0.05)",
                    height: "3rem",
                    marginTop: "0.3rem",
                    paddingLeft: "0.5rem",
                    paddingRight: "0.5rem",
                  }}
                >
                  {/* flag title */}
                  <div style={{ width: "42%", fontWeight: "bold" }}>کارت</div>

                  {/* term placement */}
                  <div
                    style={{
                      width: "12.5%",
                      fontWeight: "bold",
                      textAlign: "center",
                      transform: "translateX(1.2rem)",
                    }}
                  >
                    جایگاه
                  </div>

                  {/* flag importance */}
                  <div
                    style={{
                      width: "12.5%",
                      fontWeight: "bold",
                      textAlign: "center",
                      transform: "translateX(1.2rem)",
                    }}
                  >
                    اهمیت
                  </div>

                  {/* stat */}
                  <div
                    style={{
                      width: "33%",
                      textAlign: "end",
                      height: "100%",
                    }}
                  >
                    <div
                      style={{
                        textAlign: "center",
                        width: "100%",
                        fontWeight: "bold",
                      }}
                    >
                      آمار
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        height: "100%",
                      }}
                    >
                      <div
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          width: "20%",
                          textAlign: "center",
                        }}
                      >
                        یک
                      </div>
                      <div
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          width: "20%",
                          textAlign: "center",
                        }}
                      >
                        دو
                      </div>

                      <div
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          width: "20%",
                          textAlign: "center",
                        }}
                      >
                        سه
                      </div>
                      <div
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          width: "20%",
                          textAlign: "center",
                        }}
                      >
                        چهار
                      </div>

                      <div
                        style={{
                          borderLeft: "1px solid black",
                          borderRight: "1px solid black",
                          width: "20%",
                          textAlign: "center",
                        }}
                      >
                        جمع
                      </div>
                    </div>
                  </div>
                </div>
                {flagsMapper(record.flags, record, true)}
              </div>
            </div>
          );
        }
      },

      render: (ids, row) => {
        return flagsMapper(ids, row);
      },
    },
    {
      title: "گزینه دارای کارت",
      dataIndex: "optionsHasFlag",
      filters: [
        { value: true, text: "دارد" },
        { value: false, text: "ندارد" },
      ],
      onFilter: (value, record) => {
        return record.optionsHasFlag === value;
      },
      width: "7%",
      align: "center",
      editable: false,
      render: (value, row) => {
        if (row.isOption) {
          return;
        }
        return value === true ? (
          <Tag color="blue" style={{ width: "100%", textAlign: "center" }}>
            دارد
          </Tag>
        ) : (
          <Tag color="red" style={{ width: "100%", textAlign: "center" }}>
            ندارد
          </Tag>
        );
      },
    },
  ];

  const removeFlagHandler = (record) => {
    const newData = data;
    const newRecord = editingRecord;
    const flags = newRecord.flags;
    let index = null;
    flags.forEach((flag, i) => {
      if (flag === record.id) {
        index = i;
      }
    });
    newRecord.flags.splice(index, 1);
    const finalData = newData.map((el) => {
      if (el.id === newRecord.id) {
        return newRecord;
      }
      return el;
    });
    setData(finalData);
  };
  const onSelectFlagHandler = (record, selected) => {
    if (selected) {
      const newData = Array.from([...data]);
      const newRecord = editingRecord;
      newRecord.flags.push(record.id);
      let finalData = [];
      if (newRecord.anwser_id) {
        finalData = newData.map((el) => {
          if (el.id === newRecord.anwser_id) {
            const children = el.children.map((child) => {
              if (child.id === newRecord.id) {
                return newRecord;
              }
              return child;
            });
            return { ...el, children };
          }
          return el;
        });
      } else {
        finalData = newData.map((el) => {
          if (el.id === newRecord.id) {
            return newRecord;
          }
          return el;
        });
      }

      setData(finalData);
    } else {
      removeFlagHandler(record);
    }
  };
  const onSelectFlagForIgnoreHandler = (record, selected) => {
    const qaId = editingRecord?.isOption
      ? editingRecord.anwser_id
      : editingRecord.id;
    const answerId = editingRecord?.isOption ? editingRecord.id : null;

    const cc = getIgnoreFlagsOfQuestion(
      editingRecord?.isOption ? editingRecord?.anwser_id : editingRecord?.id,
      editingRecord?.isOption ? editingRecord?.id : null
    )
      .map((a) => a?.bom_item?.id)
      .filter((e) => e);

    const ignoreFlagsSet = new Set([
      ...(editingRecord?.ignoreFlags ?? []),
      ...cc,
    ]);
    if (selected) {
      ignoreFlagsSet.add(record.id);
    } else {
      ignoreFlagsSet.delete(record.id);
    }

    setEditingRecord({
      ...editingRecord,
      ignoreFlags: Array.from(ignoreFlagsSet),
    });

    setData((prevData) =>
      prevData?.map((rec) => {
        if (rec.id !== editingRecord.id) return rec;

        return {
          ...rec,
          ignoreFlags: Array.from(ignoreFlagsSet),
        };
      })
    );

    // update temp flag ignore list

    const newAppendFlags = Array.from(ignoreFlagsSet).map((flId) => {
      const flag = findFlagRef({ id: flId }, flags);

      return { bom_item: flag, question_id: qaId, answer_id: answerId };
    });

    const newDt = ignoreFlags.filter(
      (prev) => prev.question_id !== qaId && prev.answer_id !== answerId
    );

    newDt.push(...newAppendFlags);

    setIgnoreFlags(newDt);
  };
  useEffect(() => {
    loadData(params.epollformid);
    loadFormAdjectives();
    loadImportantQuestions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.epollformid, loadImportantQuestions]);

  useEffect(() => {
    console.warn("here i m", params.epollformid);
    // loadData(params.epollformid);
    if (!questions) {
      loadData(params.epollformid);
      console.warn("should load");
    }
    if (questions) {
      console.warn("should not load");
      const newData = Array.from([...questions]);
      setData(newData);
      if (dataRef.current === null) {
        dataRef.current = newData;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, loadData]);

  useEffect(() => {
    if (questionTypesData) {
      setQuestionTypes(questionTypesData);
    }
  }, [questionTypesData, loadData]);

  const onSave = (row, rowData) => {
    actions
      .getQuestions(params.epollformid)
      .then((questionsRef) => {
        let oldData = null;
        Array.from([...questionsRef.data]).forEach((item) => {
          const oldOptions = item.children;
          if (Array.isArray(oldOptions)) {
            oldOptions.forEach((oldOpt) => {
              if (oldOpt.id === row.id) {
                oldData = oldOpt;
              }
            });
          }
          if (item.id === row.id && !oldData) {
            oldData = item;
          }
        });
        LoadingSetter();

        const ignoreFlagList = getIgnoreFlagsOfQuestion(
          rowData?.isOption ? rowData?.anwser_id : rowData?.id,
          rowData?.isOption ? rowData?.id : null
        );

        const tagsForSave = Array.from(
          new Set([
            ...(getIgnoreTag(row.id, row.anwser_id) ?? []),
            ...(rowData?.flagTag ?? []),
          ])
        );

        saveQAAdjectives(rowData.anwser_id, rowData.id, rowData.qaAdjective);
        // if (rowData.isOption) {
        // }
        saveIgnoreTags(rowData.id, rowData.anwser_id, tagsForSave);

        saveIgnoreFlags(
          rowData?.isOption ? rowData.anwser_id : rowData.id,
          rowData?.isOption ? rowData.id : null,
          ignoreFlagList?.map((i) => i.bom_item.id) ?? []
        );

        const resetFlagsArr = rowData?.flags?.map((flId) => ({
          id: flId,
          termIndex: getFlagTermIndexVal(row, flId),
          importance: getFlagImportance(row, flId),
        }));

        api.post("/question/reset-flags", {
          epollQuestionId: row.anwser_id ? row.anwser_id : row.id,
          epollAnswerId: row.anwser_id ? row.id : null,
          epoll_form: +params.epollformid,
          flagsArr: resetFlagsArr ?? [],
        });

        if (Array.isArray(rowData.types)) {
          const removes = (oldData.types ?? [])
            .map((el) => {
              let removed = true;
              rowData.types.forEach((a) => {
                if (`${el}` === `${a}`) {
                  removed = false;
                }
              });
              if (removed) {
                return el;
              }
              return null;
            })
            .filter(function (el) {
              return el != null;
            });
          const adds = rowData.types
            .map((el) => {
              let added = true;
              oldData.types.forEach((a) => {
                if (`${el}` === `${a}`) {
                  added = false;
                }
              });
              if (added) {
                return el;
              }
              return null;
            })
            .filter(function (el) {
              return el != null;
            });
          if (Array.isArray(removes)) {
            let counter = 0;
            const req = () => {
              const remove = removes[counter];
              if (remove) {
                api
                  .post("/question/removequestiontype", {
                    epollQuestionId: row.anwser_id ? row.anwser_id : row.id,
                    epollAnswerId: row.anwser_id ? row.id : null,
                    questionTypeId: remove,
                  })
                  .then(() => {
                    if (counter === removes.length - 1) {
                      ClearLoading();
                    } else {
                      counter++;
                      req();
                    }
                  })
                  .catch(() => {
                    ClearLoading();
                    editError();
                  });
              }
            };
            req();
          }
          if (Array.isArray(adds)) {
            let counter = 0;
            const req = () => {
              const add = adds[counter];
              if (add) {
                api
                  .post("/question/addquestiontype", {
                    epollQuestionId: row.anwser_id ? row.anwser_id : row.id,
                    epollAnswerId: row.anwser_id ? row.id : null,
                    questionTypeId: add,
                  })
                  .then(() => {
                    if (counter === adds.length - 1) {
                      ClearLoading();
                    } else {
                      counter++;
                      req();
                    }
                  })
                  .catch(() => {
                    ClearLoading();
                    editError();
                  });
              }
            };
            req();
          }
        } else {
          ClearLoading();
        }
        setTimeout(() => {
          ClearLoading();
        }, 5000);
      })
      .catch((err) => {
        ClearLoading();
        console.log("catch", err);
      });
  };

  const exportData = () => {
    const all = [];
    questions.forEach((question) => {
      // first questions
      all.push({
        سوال: question.title,
        گزینه: "",
        "نام کارت": "",
        جایگاه: "",
        "ستون اول": "",
        "ستون دوم": "",
        "ستون سوم": "",
        "ستون چهارم": "",
        مجموع: "",
      });
      // flags
      const re = question?.flags?.map((fl) => {
        const flagRef = findFlag(fl);
        const flagStat = getFlagSta(fl);

        return {
          سوال: "",
          گزینه: "",
          "نام کارت": flagRef.title,
          جایگاه: getFlagTermIndexVal(question, fl),
          "ستون اول": flagStat.term1,
          "ستون دوم": flagStat.term2,
          "ستون سوم": flagStat.term3,
          "ستون چهارم": flagStat.term4,
          مجموع: flagStat.total,
        };
      });
      all.push(...(re ?? []));

      question.children?.forEach((child) => {
        all.push({
          سوال: "",
          گزینه: child.title,
          "نام کارت": "",
          جایگاه: "",
          "ستون اول": "",
          "ستون دوم": "",
          "ستون سوم": "",
          "ستون چهارم": "",
          مجموع: "",
        });
        const re2 = child?.flags?.map((fl) => {
          const flagRef = findFlag(fl);
          const flagStat = getFlagSta(fl);
          return {
            سوال: "",
            گزینه: "",
            "نام کارت": flagRef.title,
            جایگاه: getFlagTermIndexVal(child, fl),
            "ستون اول": flagStat.term1,
            "ستون دوم": flagStat.term2,
            "ستون سوم": flagStat.term3,
            "ستون چهارم": flagStat.term4,
            مجموع: flagStat.total,
          };
        });
        all.push(...(re2 ?? []));
      });
    });

    ExportExcel(all.flat(1), "سوالات");
  };

  return (
    <>
      <DataTable
        dataSource={data}
        hideComment
        hideErrorReport
        setDataSource={setData}
        editable
        keepPageOnSave
        columns={columns}
        editableKeys={editableKeys}
        setEditableRowKeys={setEditableRowKeys}
        onSave={onSave}
        permissionsPrefix="flags"
        reload={() => {
          loadData(params.epollformid);
        }}
        recordCreatorDisabled
        rowClassName={(record) => {
          const classes = [];
          if (
            Array.isArray(importantQuestions) &&
            importantQuestions.length > 0
          ) {
            const isImportant = isRecordImportant(record);
            if (isImportant) {
              classes.push("row_error");
            }
          }

          return [
            record.anwser_id ? styles.AwnserRow : null,
            record.question_type === "break" ? styles.Break : null,
            ...classes,
          ].join(" ");
        }}
        onRowEditable={(record) =>
          record.question_type === "break" ? false : true
        }
        header={{
          title: params.title,
          avatar: { icon: <ApiOutlined />, size: "large" },
          extra: (
            <Space>
              {CheckPermission("export_excel", permissions) && (
                <Button onClick={exportData}>خروجی اکسل</Button>
              )}
            </Space>
          ),
        }}
      />

      {/* connect flags modal */}
      <Modal
        title={editingRecord && editingRecord.title}
        destroyOnClose
        centered
        width="100%"
        open={openModal}
        onOk={() => setOpenModal(false)}
        closable={false}
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <Flags
          rowSelection={{
            hideSelectAll: true,
            onSelect: onSelectFlagHandler,
            selectedRowKeys: editingRecord
              ? Array.isArray(editingRecord.flags)
                ? editingRecord.flags.map((flag) => {
                    return flag;
                  })
                : null
              : null,
          }}
        />
      </Modal>

      {/* ignore flags modal */}
      <Modal
        title={editingRecord?.title}
        destroyOnClose
        centered
        width="100%"
        open={openIgnoreFlagModal}
        onOk={() => setOpenIgnoreFlagModal(false)}
        closable={false}
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <Flags
          rowSelection={{
            hideSelectAll: true,
            onSelect: onSelectFlagForIgnoreHandler,
            selectedRowKeys: getIgnoreFlagsOfQuestion(
              editingRecord?.isOption
                ? editingRecord?.anwser_id
                : editingRecord?.id,
              editingRecord?.isOption ? editingRecord?.id : null
            )
              .map((a) => a?.bom_item?.id)
              .filter((e) => e),
          }}
        />
      </Modal>

      {/* important questions modal */}
      <Modal
        title="مدیریت سوالات مهم"
        destroyOnClose
        centered
        width="800px"
        open={openImportantQuestionsModal}
        onOk={() => setOpenImportantQuestionsModal(false)}
        onCancel={() => setOpenImportantQuestionsModal(false)}
        okText="بستن"
        cancelText="انصراف"
      >
        <Space direction="vertical" style={{ width: "100%" }} size="large">
          <div>
            <Space>
              <Input
                placeholder="شناسه سوال"
                value={newQuestionNumber}
                onChange={(e) => setNewQuestionNumber(e.target.value)}
                type="number"
                style={{ width: 200 }}
              />
              <Input
                placeholder="شناسه گزینه (اختیاری)"
                value={newAnswerId}
                onChange={(e) => setNewAnswerId(e.target.value)}
                type="number"
                style={{ width: 200 }}
              />
              <Button
                type="primary"
                onClick={() =>
                  addImportantQuestion(newQuestionNumber, newAnswerId)
                }
              >
                افزودن
              </Button>
            </Space>
          </div>
          <Table
            dataSource={importantQuestions}
            rowKey="id"
            pagination={{ pageSize: 10 }}
            columns={[
              {
                title: "شماره سوال",
                dataIndex: "questionNumber",
                key: "questionNumber",
              },
              {
                title: "شناسه پاسخ",
                dataIndex: "answerId",
                key: "answerId",
                render: (value) => (value ? value : "-"),
              },
              {
                title: "عملیات",
                key: "action",
                render: (_, record) => (
                  <Popconfirm
                    title="آیا از حذف این سوال مهم اطمینان دارید؟"
                    onConfirm={() => deleteImportantQuestion(record.id)}
                    okText="بله"
                    cancelText="خیر"
                  >
                    <Button danger icon={<DeleteOutlined />} size="small">
                      حذف
                    </Button>
                  </Popconfirm>
                ),
              },
            ]}
          />
        </Space>
      </Modal>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    loading: state.loading,
    error: state.error,
    permissions: state.userData ? state.userData.permissions : null,
    flags: state.flags,
    questions: state.questions,
    questionTypesData: state.questionTypes,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ClearError: () => dispatch(actions.ClearError()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
    LoadingSetter: () => dispatch(actions.LoadingSetter()),
    ErrorSetter: () => dispatch(actions.ErrorSetter()),
    loadData: (epollformid) => dispatch(actions.getDatabase(epollformid)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(QuestionsToFlags);
